import { ENDPOINT_WORKSPACE_SETTINGS } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface UpdateAiSettingsRequest {
  aiEnabled?: boolean
}

export interface AiSettingsResponse {
  workspaceId: string
  workspaceSlug: string
  aiEnabled: boolean
}

export async function updateAiSettings(
  workspaceSlug: string,
  request: UpdateAiSettingsRequest,
): Promise<AiSettingsResponse> {
  const response = await AuthAxios.patch<AiSettingsResponse>(
    `${ENDPOINT_WORKSPACE_SETTINGS}/${workspaceSlug}/settings/ai`,
    request,
  )
  return response.data
}

export async function getAiSettings(
  workspaceSlug: string,
): Promise<AiSettingsResponse> {
  const response = await AuthAxios.get<AiSettingsResponse>(
    `${ENDPOINT_WORKSPACE_SETTINGS}/${workspaceSlug}/settings/ai`,
  )
  return response.data
}
